(function ($) {

  Drupal.behaviors.mpp_project_e = {
    attach: function (context, settings) {
      var productsArray = page_data['custom-mpp'].products;

      $(".js-product-brief").each( function() {
        var productId = $(this).attr('data-product-id');
        var productData = _.find(productsArray, function(p){ return p.PRODUCT_ID == productId; });
        site.product.view.brief({
          containerNode: this,
          productData: productData
        });
      });

      site.product.view.miscFlagAlign($('.mpp__product'));
      site.product.view.equalRowHeight($('.mpp__product'));

      //quickshop test
      function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
        }
        return vars;
      }
      var qs = getUrlVars()['qs'];
      if(qs){
        $('.qs_test').removeClass('hidden');
        $('.qs_test').click(function(event) {
          var pid = $(this).attr('data-product-id');
          var quickshopData = _.find(productsArray, function(p){ return p.PRODUCT_ID == pid; });
          site.quickshop(quickshopData);
        });
      //$('.qs_test').eq(1).trigger('click');
      }

      // Procuct Sort
      site.productSort.init(productsArray);
      // Product compare nav
      site.mppCompareInit(productsArray);

      $('.mpp-2-column .mpp__product').each(function() {
        var backgroundImg = $(this).find('.product_brief__image').css('background-image');
        var productImage = backgroundImg.substr(backgroundImg.indexOf("424/") + 4, 13);
        var newBgImg = 'background-image:url(\'/media/export/cms/mpp/two-column-mpp/' + productImage + '_370x508_0.jpg\')';
        $(this).find('.product_brief__image').attr('style', newBgImg);
      });

      // Temporary functionality for node 26026
      $('.node-26026 .node-29050 img.hero-block__hero-image').click(function() {
        window.location.href = "/product/681/36143/Product-Catalog/Skincare/New-Dimension/Shape-Fill-Expert-Serum";
      });
      $('.node-26026').find('.mpp__product-sort-container').each(function() {
        $(this).hide();
      });

      // Temporary functionality for node 26026
      $('.node-29190 .node-29186 img.hero-block__hero-image').click(function() {
        window.location.href = "/product/681/36143/Product-Catalog/Skincare/New-Dimension/Shape-Fill-Expert-Serum";
      });
      $('.node-29190').find('.mpp__product-sort-container').each(function() {
        $(this).hide();
      });
    }
  };

})(jQuery);
